<template>
  <RouterView />
  <Toast position="bottom-right" />
  <ConfirmDialog />
</template>
